module.exports = __webpack_public_path__ + "assets/img/ic-gift.c167ac9b.svg";